import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { DEFAULT_LOCALE, isAppLocale, type AppLocale } from '~/utils/i18n';

const LocaleLayout = () => {
  Route.useRouteContext() as { locale: AppLocale };
  return <Outlet />;
};

export const Route = createFileRoute('/$locale')({
  beforeLoad: ({ params, context }) => {
    const requested = params.locale?.toLowerCase();

    if (!isAppLocale(requested)) {
      throw redirect({
        to: '/$locale',
        params: { locale: DEFAULT_LOCALE },
        replace: true,
      });
    }

    return {
      ...context,
      locale: requested,
    };
  },
  component: LocaleLayout,
});
